export default {
  subscription: {
    manage: "管理订阅",
    page_title: "订阅管理",
    page_subtitle: "管理您的订阅设置和自动续订偏好",
    current_subscription: "当前订阅",
    plan: "套餐",
    billing_cycle: "计费周期",
    status: "状态",
    subscription_control: "订阅控制",
    auto_renew_cancelled: "自动续订已被取消，服务将在{date}到期后停止。",
    cancel_effect: "取消订阅将在当前计费周期结束后生效。您的订阅将持续有效至{date}。",
    restore_prompt:
      "您的订阅已被取消或将在当前计费周期结束后取消。要继续使用我们的服务，请恢复您的订阅。",
    cancel_processing: "您的订阅取消请求正在处理中，将在当前计费周期结束后生效。",
    restore_processing: "您的订阅恢复请求正在处理中。",
    expired_desc: "您的订阅已过期。请更新您的付款信息以恢复服务。",
    paused: "您的订阅当前已暂停。无法执行取消或恢复操作。",
    trialing: "您当前正处于试用期。试用期结束后，订阅将自动转换为付费订阅。",
    no_action: "您当前的订阅状态不支持任何操作。",
    cancel_subscription_btn: "取消订阅",
    restore_subscription_btn: "恢复订阅",
    restoring: "恢复中...",
    cancelling: "取消中...",
    status_unavailable: "状态不可用",
    no_active_subscription: "您没有活跃的订阅",
    choose_plan: "选择套餐",
    cancel_modal_title: "取消订阅",
    cancel_confirm:
      "您确定要取消订阅吗？这将在当前计费周期结束后生效（{date}）。之后，您的订阅将被停用，您将失去对高级功能的访问权限。",
    reason_label: "原因（可选）：",
    reason_placeholder: "请告诉我们您取消的原因...",
    status_updated: "订阅状态已更新",
    cancel_request_submitted: "订阅取消请求已提交",
    cancel_failed: "订阅取消失败",
    restore_request_submitted: "订阅恢复请求已提交",
    restore_failed: "订阅恢复失败",
    active: "活跃",
    canceled: "已取消",
    cancel_pending: "取消待处理",
    restore_pending: "恢复待处理",
    past_due: "逾期",
    paused_status: "已暂停",
    trialing_status: "试用中",
    next_cycle_cancel: "下一周期取消",
    unknown_status: "未知状态",
    monthly: "月付",
    yearly: "年付",
  },
  invoices: {
    recent: "最近发票",
    number: "发票编号",
    order_no: "订单号",
    amount: "金额",
    status: "状态",
    created_at: "创建时间",
    actions: "操作",
    status_issued: "已开具",
    status_paid: "已支付",
    status_voided: "已作废",
    view_all: "查看全部",
  },
  orders: {
    no: "订单号",
    plan_type: "套餐类型",
    duration: "时长",
    amount: "金额",
    status: "状态",
    paid_at: "支付时间",
    created_at: "创建时间",
    actions: "操作",
    quantity: "数量",
    status_pending: "待处理",
    status_paid: "已支付",
    status_failed: "失败",
    status_refunded: "已退款",
    refund_pending: "退款待处理",
    refund_failed: "退款失败",
    cancelled: "已取消",
    expired: "已过期",
    days: "天",
    cancel_confirm: "您确定要取消此订单吗？",
    delete_confirm: "您确定要删除此订单吗？",
    downloading_invoice: "正在下载发票...",
    download_failed: "下载失败",
    check_refund: "正在检查退款资格...",
    refund_not_eligible: "不符合退款条件",
    check_refund_failed: "检查退款资格失败",
    prorated_refund_title: "按比例退款",
    prorated_refund_content: "此退款将根据您的使用情况按比例计算。",
    credits_refund_content: "此退款将根据剩余积分按比例计算。",
    full_refund_title: "全额退款",
    full_refund_content: "您有资格获得全额退款。",
    request_refund: "申请退款",
    processing_refund: "正在处理退款请求...",
    refund_request_failed: "申请退款失败",
    refund_reason: "退款原因",
    refund_reason_placeholder: "请提供退款原因...",
    refund_reason_required: "退款原因是必需的",
    refund_conditions: "退款条件",
    no_report_generated: "未生成报告",
    no_calculations_performed: "未执行计算",
    no_api_used: "未使用API",
    subscription_period: "订阅期间",
    subscription_details: "订阅详情",
    total_days: "总天数",
    remaining_days: "剩余天数",
    refund_amount: "退款金额",
    refund_reasons: {
      order_not_found: "找不到订单",
      unauthorized: "未授权访问",
      order_not_completed: "只有已完成的订单才能退款",
      subscription_not_found: "找不到订阅",
      paid_features_used: "订阅期间使用了付费功能",
      internal_error: "检查退款资格时发生内部错误",
    },
    calculation_quota: "计算积分",
    report_quota: "报告积分",
    quota_info: "购买 {purchased} {type}，已使用 {used}，剩余 {remaining}",
    quota_detail: "购买 {purchased}，已使用 {used}，剩余 {remaining}",
    no_credits_used: "未使用积分",
    refund_requested: "退款申请提交成功",
    refund_pending_approval: "退款申请已提交。退款正在等待批准，可能需要一些时间处理。",
    refund_approved: "退款批准成功",
    refund_rejected: "退款申请被拒绝",
    refund_success: "退款成功",
    refund_processing: "退款处理中",
    refund_success_message: "我们已成功处理您的退款。资金到账可能需要最多5天时间。",
    refund_processing_message: "您的退款仍在处理中，请耐心等待。",
    checking_order_status: "正在检查订单状态...",
  },
};
